import axiosInstance from '../utils/setupAxios';

export const adminGenerateSong = (payload) =>
  axiosInstance.post('/songs/admin/generate', payload);

export const adminSyncTasks = (task_ids) =>
  axiosInstance.post('/songs/admin/sync-tasks', { task_ids });

export const adminSyncAllTasks = () =>
  axiosInstance.post('/songs/admin/sync-admin-songs');

export const getSongShareData = (task_id) =>
  axiosInstance.get(`/songs/share/${task_id}/data`);
